var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { useState, useEffect, useCallback } from 'react';
import { useHistory } from 'react-router-dom';
import { Grid } from '@material-ui/core';
import { connect } from 'react-redux';
import Loadable from 'react-loadable';
import * as _ from "lodash";
import { useTranslation } from 'react-i18next';
import { getPublishersByCurrentUser, checkRoleUser, getCurrentUser } from '../../utils/CommonUtil';
import * as Constant from '../../utils/Constant';
import * as LocalStorageUtil from '../../utils/LocalStorageUtil';
import { LoadingWidget } from '../../components/common/loading/loading';
import MainLayout from '../../layouts/MainLayout';
import { updateDefaultTemplate as updateDefaultTemplateFn, updateUserTemplate as updateUserTemplateFn, getMetrics } from '../../services/widget-service';
import { getWidgets, getTemplatePublisher, getTemplateUser, updateTemplateSuccess, updateUserTemplateSuccess } from '../../store/widget/actions';
import { widgetData, widgetError, isLoadingWidget, defaultTemplateData, defaultTemplateError, isLoadingDefaultTemplate, userTemplateData, userTemplateError, updateTemplateData, updateUserTemplateData } from '../../store/widget/reducer';
import { ROLE_ADMIN, ROLE_OPERATOR, ROLE_SUPER_ADMIN } from '../../utils/Constant';
import './index.scss';
var SummaryWidget = Loadable({
    loader: function () { return import('../../components/sample-widgets/summary/summary'); },
    loading: function () { return React.createElement(LoadingWidget, null); },
    render: function (loaded, props) {
        var SummaryComponent = loaded.default;
        return React.createElement(SummaryComponent, __assign({}, props));
    }
});
var ChartWrapperAdd = Loadable({
    loader: function () { return import('./components/widgetWrapperAdd'); },
    loading: function () { return React.createElement(LoadingWidget, null); },
    render: function (loaded, props) {
        var ChartWrapperComponent = loaded.default;
        return React.createElement(ChartWrapperComponent, __assign({}, props));
    }
});
var AddWidget = function (props) {
    var t = useTranslation().t;
    var publishers = getPublishersByCurrentUser();
    var history = useHistory();
    var _a = useState(), dataDynamicWidget = _a[0], setDataDynamicWidget = _a[1];
    var _b = useState([]), widgetDatas = _b[0], setWidgetDatas = _b[1];
    var _c = useState("CHART"), curentTab = _c[0], setCurentTab = _c[1];
    var _d = useState("DEFAULT"), templateType = _d[0], setTemplateType = _d[1];
    var _e = useState([]), medias = _e[0], setMedias = _e[1];
    var _f = useState(), templates = _f[0], setTemplates = _f[1];
    var _g = useState(), userTemplates = _g[0], setUserTemplates = _g[1];
    var _h = useState(), widgetSelected = _h[0], setWidgetSelected = _h[1];
    var _j = useState(), metricList = _j[0], setMetricList = _j[1];
    var _k = useState(publishers[0]), publisher = _k[0], setPublisher = _k[1];
    var currentUser = getCurrentUser();
    var dataLineChart = [
        { name: "Pubdesk Inventory 1", color: "#334333", data: [{ date: 959792400000, value: 20 }, { date: 961002000000, value: 15 }, { date: 961606800000, value: 40 }, { date: 962211600000, value: 30 }] },
        { name: "Pubdesk Inventory 2", color: "#9140e5", data: [{ date: 959792400000, value: 15 }, { date: 961002000000, value: 13 }, { date: 961606800000, value: 30 }, { date: 962211600000, value: 25 }] }
    ];
    useEffect(function () {
        document.title = t("page.add_widget") + Constant.APP_NAME;
        var location = props.location;
        getMetricList();
        var foundPublisherSelected = publishers.find(function (publisher) { return publisher.selected; });
        var publisherSelected = foundPublisherSelected ? foundPublisherSelected : publishers[0];
        setPublisher(publisherSelected);
        props.dispatch(getTemplatePublisher(publisherSelected.id));
        props.dispatch(getTemplateUser(publisherSelected.id));
        if (location.search) {
            var stateVariable = location.search.substring(1).split("?")[0];
            if (stateVariable) {
                var variableArr = stateVariable.split("&&");
                if (variableArr && variableArr.length) {
                    var templateType_1 = variableArr[0] ? variableArr[0].split("=")[1] : "DEFAULT";
                    var medias_1 = getCurrentMedia();
                    if (checkDisplayDefaultTab()) {
                        if (templateType_1 == "DEFAULT") {
                            setCurentTab("CHART");
                        }
                        else {
                            setCurentTab("ORTHERS");
                        }
                    }
                    else {
                        setCurentTab("ORTHERS");
                    }
                    setTemplateType(templateType_1);
                    setMedias(medias_1);
                    if (medias_1) {
                        var mediaIds = medias_1.map(function (media) { return media.id; });
                        mediaIds = mediaIds.join();
                        props.dispatch(getWidgets({ mediaIds: mediaIds }));
                    }
                }
            }
        }
        return (function () {
            props.dispatch(updateTemplateSuccess(null));
            props.dispatch(updateUserTemplateSuccess(null));
        });
    }, []);
    useEffect(function () {
        if (props.widgetData) {
            checkAndAddWidget(props.widgetData);
        }
    }, []);
    useEffect(function () {
        if (props.widgetData) {
            checkAndAddWidget(props.widgetData);
        }
    }, [props.widgetData, curentTab]);
    useEffect(function () {
        if (props.templateData) {
            setTemplates(props.templateData);
        }
    }, [props.templateData]);
    useEffect(function () {
        if (props.userData) {
            setUserTemplates(props.userData);
        }
    }, [props.userData]);
    var moveCard = useCallback(function (dragIndex, hoverIndex) {
    }, [dataDynamicWidget]);
    var getCurrentMedia = function () {
        var mediaJson = LocalStorageUtil.getItem(LocalStorageUtil.CURRENT_MEDIA);
        if (mediaJson) {
            var currentMedia = JSON.parse(mediaJson);
            return currentMedia;
        }
        return null;
    };
    var getMetricList = function () { return __awaiter(void 0, void 0, void 0, function () {
        var metrics, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, getMetrics()];
                case 1:
                    metrics = _a.sent();
                    // metrics = metrics.filter((metric: any) => {
                    //   if (currentUser && currentUser.type === "EXTERNAL" && metric.publisherVisibility == Constant.PUBLISHER_VISIBILITY_INTERNAL) {
                    //     return false;
                    //   }
                    //   return true;
                    // });
                    setMetricList(metrics);
                    return [3 /*break*/, 3];
                case 2:
                    error_1 = _a.sent();
                    console.log("Error Metric", error_1);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var checkAndAddWidget = function (widgetData) {
        var widgets = _.sortBy(widgetData, [function (w) { return w.name; }]);
        widgets = widgets.filter(function (widget) {
            if (widget.presentationType == "CHART" && widget.code != Constant.WIDGET_BAR_CHART) {
                return true;
            }
            // if (curentTab != "CHART" && widget.presentationType != "CHART") {
            //   return true;
            // }
            return false;
        });
        widgets = widgets.map(function (widget) {
            widget.selected = false;
            return widget;
        });
        setWidgetDatas(widgets);
    };
    var onAddWidget = function (index, event) {
        var widgetList = _.clone(widgetDatas);
        widgetList[index].selected = !widgetList[index].selected;
        setWidgetDatas(widgetList);
    };
    var onCloseSettingWidget = function (index, event) {
        var widgetList = _.clone(widgetDatas);
        widgetList[index].selected = false;
        setWidgetDatas(widgetList);
    };
    var addWidgetToDashboard = function (param, dataSelected) {
        if (param && ((curentTab == "CHART" && templates) || (curentTab != "CHART" && userTemplates))) {
            var template_1 = {
                widgets: []
            };
            var templateCode = curentTab == "CHART" ? Constant.DEFAULT_TEMPLATE : Constant.USER_TEMPLATE;
            template_1.widgets = curentTab == "CHART" ? templates.widgets || [] : userTemplates.widgets || [];
            template_1.widgets = _.sortBy(template_1.widgets, ['order', 'widget.presentationType']);
            if (templateCode == Constant.DEFAULT_TEMPLATE) {
                template_1.publisherId = publisher.id;
            }
            var foundLastHaftWidget = _.findLastIndex(template_1.widgets, function (widgetData) { return widgetData.widget.displayType == "HALF"; });
            var orderTemp = template_1.widgets.length + 1;
            var isHasAddWidget = false;
            var indexHaftOrder = -1;
            template_1.widgets = template_1.widgets.map(function (widgetTemplate, index) {
                if (foundLastHaftWidget >= 0) {
                    if (foundLastHaftWidget == index) {
                        if (index == 0 || (index > 0 &&
                            template_1.widgets[index - 1].widget.displayType != "HALF")) {
                            isHasAddWidget = true;
                            orderTemp = template_1.widgets[index].order + 1;
                            indexHaftOrder = index;
                        }
                        else {
                            if (index == (template_1.widgets.length - 1)) {
                                orderTemp = widgetTemplate.order + 1;
                            }
                        }
                    }
                    else {
                        if (index == template_1.widgets.length - 1 && !isHasAddWidget) {
                            orderTemp = widgetTemplate.order + 1;
                        }
                    }
                }
                else {
                    if (index == template_1.widgets.length - 1 && !isHasAddWidget) {
                        orderTemp = widgetTemplate.order + 1;
                    }
                }
                return {
                    id: widgetTemplate.id,
                    // displayType: widgetTemplate.displayType ? widgetTemplate.displayType : "FULL",
                    widgetId: widgetTemplate.widget.id,
                    position: widgetTemplate.position,
                    setting: widgetTemplate.setting,
                    order: indexHaftOrder < 0 || indexHaftOrder == index ? widgetTemplate.order : widgetTemplate.order + 1
                };
            });
            template_1.widgets.push({
                widgetId: dataSelected.id,
                position: "CENTER_PANEL",
                order: orderTemp,
                setting: param.defaultSetting ? param.defaultSetting : null
            });
            updateDefault(template_1, templateCode);
        }
        else {
            setWidgetSelected(null);
        }
    };
    var updateDefault = function (template, type) { return __awaiter(void 0, void 0, void 0, function () {
        var error_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 5, , 6]);
                    if (!(type === Constant.DEFAULT_TEMPLATE)) return [3 /*break*/, 2];
                    return [4 /*yield*/, updateDefaultTemplateFn(template)];
                case 1:
                    _a.sent();
                    return [3 /*break*/, 4];
                case 2: return [4 /*yield*/, updateUserTemplateFn(template)];
                case 3:
                    _a.sent();
                    _a.label = 4;
                case 4:
                    redirectDashboard(type);
                    setWidgetSelected(null);
                    return [3 /*break*/, 6];
                case 5:
                    error_2 = _a.sent();
                    setWidgetSelected(null);
                    console.log(error_2);
                    return [3 /*break*/, 6];
                case 6: return [2 /*return*/];
            }
        });
    }); };
    var redirectDashboard = function (type) {
        history.push("/dashboard?tab=" + type);
    };
    var changeTab = function (tabType) {
        if (tabType == "CHART" && !checkDisplayDefaultTab()) {
            return;
        }
        setCurentTab(tabType);
    };
    var checkDisplayDefaultTab = function () {
        if (currentUser && currentUser.type == "INTERNAL" && (checkRoleUser(ROLE_OPERATOR) || checkRoleUser(ROLE_SUPER_ADMIN))) {
            return true;
        }
        if (currentUser && currentUser.type === "EXTERNAL" && checkRoleUser(ROLE_ADMIN)) {
            return true;
        }
        return false;
    };
    var renderWidgetItem = function (widgetData, index) {
        if (currentUser && currentUser.type === "EXTERNAL") {
            if (widgetData.code !== Constant.WIDGET_PUBLISHER_MEDIAN_CPM) {
                return React.createElement(Grid, { item: true, xs: 4, key: widgetData.id, className: "add-widget-event" },
                    React.createElement(ChartWrapperAdd, { data: widgetData, chartType: widgetData.code, medias: medias, index: index, onAddWidget: onAddWidget, publisher: publisher, onCloseSettingWidget: onCloseSettingWidget, onAddWidgetToDashboard: addWidgetToDashboard, metrics: metricList }));
            }
            return null;
        }
        else {
            return React.createElement(Grid, { item: true, xs: 4, key: widgetData.id, className: "add-widget-event" },
                React.createElement(ChartWrapperAdd, { data: widgetData, chartType: widgetData.code, medias: medias, index: index, onAddWidget: onAddWidget, publisher: publisher, onCloseSettingWidget: onCloseSettingWidget, onAddWidgetToDashboard: addWidgetToDashboard, metrics: metricList, isHideForExternal: props.currentUserInfo }));
        }
    };
    return (React.createElement(MainLayout, null,
        React.createElement("div", { className: "layout-static" },
            React.createElement("div", { className: "static-content-wrapper" },
                React.createElement("div", { className: "static-content" },
                    React.createElement("div", { className: "page-content page-publishers" },
                        React.createElement("div", { className: "container-fluid container-dashboard" },
                            React.createElement("div", { className: "row" },
                                React.createElement("div", { className: "title-container" },
                                    React.createElement("h3", { className: "title-add-widget" }, t("add_widget.title")),
                                    React.createElement("div", null,
                                        React.createElement("a", { className: "add-widget-back-dashboard", href: "#/dashboard" }, t('widget_details.back_to_dashboard')))),
                                React.createElement("p", { className: "note-add-widget" }, "\u30AB\u30FC\u30C9\u3092\u9078\u629E\u3057\u3066\u4FDD\u5B58\u3057\u3066\u304F\u3060\u3055\u3044\u3002\u30C0\u30C3\u30B7\u30E5\u30DC\u30FC\u30C9\u306B\u8FFD\u52A0\u3055\u308C\u307E\u3059\u3002\u76F4\u8FD1\u306E\u6210\u679C\u3092\u671F\u9593\u30FB\u6307\u6A19\u30FB\u30C7\u30D0\u30A4\u30B9\u3092\u5207\u308A\u66FF\u3048\u3066\u78BA\u8A8D\u3067\u304D\u307E\u3059\u3002"),
                                React.createElement(Grid, { container: true, direction: "row", justify: "flex-start", alignItems: "center", className: "container-add-widget", spacing: 1 },
                                    React.createElement(Grid, { item: true },
                                        React.createElement("button", { className: "btn btn-default btn-tab-template " + (curentTab === "CHART" ? "btn-tab-template-selected" : "") + " " + (checkDisplayDefaultTab() ? "" : "btn-pb-template-disabled"), onClick: function (e) { return changeTab("CHART"); } },
                                            React.createElement("span", null, t('dashboard.default')))),
                                    React.createElement(Grid, { item: true },
                                        React.createElement("button", { className: "btn btn-default btn-tab-template " + (curentTab === "ORTHERS" ? "btn-tab-template-selected" : ""), onClick: function (e) { return changeTab("ORTHERS"); } },
                                            React.createElement("span", null, t('dashboard.account'))))),
                                React.createElement(Grid, { container: true, spacing: 2, direction: "row", justify: "flex-start" },
                                    widgetDatas ?
                                        widgetDatas.map(function (data, index) { return (data.presentationType === "CHART" ?
                                            renderWidgetItem(data, index) : null
                                        // ( data.code === Constant.WIDGET_SUMMARY ? 
                                        //   <Grid item
                                        //     xs={4}
                                        //     key={data.id}
                                        //     className="add-widget-event">
                                        //     <SummaryWidget
                                        //       title={t('summary.overall_summary')}
                                        //       data={dataLineChart}
                                        //       key={6}
                                        //       index={6}
                                        //       id={6}
                                        //       moveCard={moveCard}
                                        //     />
                                        //   </Grid> : null
                                        // )
                                        ); }) : null,
                                    props.isLoadingWidget ? React.createElement(LoadingWidget, null) : null)))))))));
};
function mapStateToProps(state) {
    return {
        widgetData: widgetData(state),
        widgetError: widgetError(state),
        isLoadingWidget: isLoadingWidget(state),
        templateData: defaultTemplateData(state),
        templateError: defaultTemplateError(state),
        isLoadingTemplate: isLoadingDefaultTemplate(state),
        userData: userTemplateData(state),
        userError: userTemplateError(state),
        updateTemplateData: updateTemplateData(state),
        updateUserTemplateData: updateUserTemplateData(state),
    };
}
export default connect(mapStateToProps)(AddWidget);
